<template>
    <div class="m-3 bg-white border shadow-xl p-6">
        <h3 class="text-center mt-0">
            {{ service.name }}
        </h3>
        <div class="text-sm my-3">{{ service.description }}</div>

        <p :class="service.campaigne != null ? 'line-through mb-0' : ''">
            Fra: <b>{{ service.pricesFrom }} kr</b> + mva
        </p>

        <div v-if="service.campaigne != null">
            <p class="text-green-600">
                Fra: 
                <b>{{ service.campaigne.priceFrom }} kr</b>
                + mva
            </p>
            <p class="text-sm">{{ service.campaigne.message }}</p>
        </div>

        <b>Inkluderer:</b>
        <ul class="mt-2">
            <li v-for="item in service.includes" class="flex items-center mb-2">
                <img src="/icons/check.png" alt="" class="w-3 mr-4">
                {{ item }}
            </li>
        </ul>

        <div class="flex justify-center">
            <a href="/contact" class="btn w-32 mt-8 py-2">
                Ta kontakt
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        service: {
            type: Object,
            required: true
        }
    }
}
</script>